import React from "react";
import { toast } from "react-toastify";

import ImageFallback from "../../assets/images/image-fallback.webp";

const Image = ({
  src,
  alt = "image",
  fallback = ImageFallback,
  width,
  height,
  className = "",
  loading = "lazy",
}) => {
  const handleError = (e) => {
    if (e.target.src !== fallback) {
      e.target.src = fallback;
      toast.error("Image failed to load");
    }
  };

  return (
    <img
      src={src || fallback}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      className={`image ${className}`}
      onError={handleError}
    />
  );
};

export default Image;

